import React from 'react';
import {Row, Col, Container} from 'reactstrap';
import EventsInComing from './EventsInComing';
import styles from './HomePage.module.css';
import ickasso from '../img/ickasso.jpg';
import Galery from '../Galerie/Galery';

function HomePage(props) {
  return (
    <Container fluid className="px-0">
      <section className={styles.homePageSection}>
        <Row
          className={`${styles.firstRow} align-items-center justify-content-center mx-0`}
        >
          <Col
            xl="4"
            lg="5"
            md="8"
            xs="11"
            className={`${styles.imgPresMobile} text-center mb-4 mb-lg-0`}
          >
            <img
              src={ickasso}
              alt="Isabelle Conrozier Kassovic"
              className={`${styles.imgPres} img-fluid rounded shadow`}
            />
          </Col>

          <Col
            xl={{size: 5, offset: 1}}
            lg={{size: 6, offset: 0}}
            md="10"
            xs="11"
            className={styles.firstParagraphMobile}
          >
            <h1 className={styles.firstTitle}>IcKasso</h1>
            <p className="lead">
              Née en 1959 aux Etats-Unis, d&apos;un père slave et d&apos;une
              mère française, <b>Isabelle Conrozier Kassovic (IcKasso)</b> est une
              artiste spécialisée dans la sculpture en terre cuite peinte et la
              peinture en acrylique.

            </p>
            <p>
              Titulaire d&apos;un CAPES et d&apos;une maîtrise de Mathématiques,
              elle a suivi une formation d&apos;arts plastiques à
              l&apos;Université de Pen Valley à Kansas City (Missouri) en
              1990-91.
            </p>
          </Col>
        </Row>

        <Row className={`${styles.secondRow} justify-content-center mx-0 mt-5`}>
          <Col className={styles.imageText} xl="10" lg="11" md="11" xs="11">
            <p>
              Elle a ensuite vécu à Singapour (1992-96), où elle a développé sa
              technique de la sculpture en terre cuite dans l&apos;atelier de
              <b> Lim Meng Khuong</b> : elle y a notamment acquis la maîtrise du nu
              académique avant de développer son propre style, décliné en
              diverses collections.
            </p>
            <p>
              Installée au Rouret depuis 1998, elle a créé son propre atelier et
              expose depuis 2002 sous le nom d&apos;artiste <b>IcKASSO</b>.
            </p>
          </Col>
        </Row>
      </section>

      <section>
        <Galery />
      </section>

      <section className={styles.eventsInComingSection}>
        <EventsInComing />
      </section>
    </Container>
  );
}

export default HomePage;
